// @flow
import { handleResponseOld, makeGet } from './helpers';

type FetchCatalogLocationsParams = {
    deployment: string,
};

export default {
    fetchCatalogLocations: ({ deployment }: FetchCatalogLocationsParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makeGet({ deployment, path: '<ITEM-API>catalog-locations' });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
};
